import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Formik } from "formik";
import {
  Title,
  Text,
  Margin,
  Input,
  Button,
  Loading,
  ErrorMessage,
  Alert
} from "~/components/elements";
import * as S from "./styles";
import { schema } from "./validation";
import { Creators as AuthenticationActions } from "~/store/modules/authentication/actions";
import { Creators as SignUpActions } from "~/store/modules/signUp/actions";
import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";
import { scrollTo } from "~/utils/tools";

export default function FormLogin({ participanteHash }) {
  const mobile = isMobile();
  const dispatch = useDispatch();
  const location = useLocation();
  const sending = useSelector((state) => state.authentication.auth.sending);
  const logged = useSelector((state) => state.authentication.auth.loginToken);

  const Code = window.location.pathname.split("/")[2];

  const sendingValidate = useSelector((state) => state.signUp.validate.sending);
  const errorMessageValidate = useSelector(
    (state) => state.signUp.validate.message
  );
  const successValidate = useSelector((state) => state.signUp.validate.success);

  const completeSignUp = useSelector(
    (state) => state.authentication.auth.user.cadastroCompleto
  );
  const errorMessage = useSelector(
    (state) => state.authentication.auth.errorMessage
  );
  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;
  const initialValues = {
    Email: "",
    Senha: "",
  };

  useEffect(() => {
    scrollTo(700);
    const isCodeValido = (window.location.pathname.split("/")[2] || "").length > 40;
    if (isCodeValido) {
      dispatch(
        SignUpActions.sendConfirmCode({
          Code: Code,
          // EnviarEmail: true,
          confirm_email: true,
          url: url,
          origin: origin,
        })
      );
    }
    return () => {
      dispatch(SignUpActions.setConfirmData());
    };
  }, [dispatch, Code, url, origin]);

  useEffect(() => {
    dispatch(AuthenticationActions.setAuthenticationMessage());
    if (logged) {
      history.push({ pathname: "/minha-conta" });
    }
    return () => {
      dispatch(AuthenticationActions.setAuthenticationMessage());
    };
  }, [dispatch, logged, completeSignUp]);
  return (
    <>
      <S.FormText>
        <Margin mt={mobile ? 5 : 8} mb={3}>
          <Title as="1" levelDesktop="2" level="4" primary={false}>
            <strong>Fazer Login</strong>
          </Title>
        </Margin>

        <Margin mb={4}>
          {sendingValidate ? (
            <Loading />
          ) : (
            <>
              {!successValidate && errorMessageValidate && (
                <ErrorMessage inset>
                  Desculpe. Não conseguimos confirmar seu email.
                </ErrorMessage>
              )}
              {successValidate && (
                <>
                  <Text level={"2"} emphasis={false} primary>
                    <strong>
                      E-mail verificado. Agradecemos a confirmação!
                    </strong>
                  </Text>
                  <Text level={"2"} emphasis={false} primary>
                    Agora é só entrar na conta e registrar sua compra.
                  </Text>
                </>
              )}
            </>
          )}
          {!Code && (
            <Text level={"2"} emphasis={false} primary>
              Que bom te ver de novo! <br />
              Informe seu e-mail e senha para entrar na conta.
            </Text>
          )}
        </Margin>
      </S.FormText>
      <S.FormHolder>
        <Margin mb={3}>
          <Formik
            initialValues={initialValues}
            validationSchema={schema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              dispatch(
                AuthenticationActions.sendAuthentication({
                  ...values,
                  url: url,
                  origin: origin,
                })
              );
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isValid,
              dirty,
            }) => (
              <S.FormLimiter onSubmit={handleSubmit}>
                <Margin mb={3}>
                  <Input
                    label="E-mail"
                    placeholder="Digite seu e-mail cadastrado"
                    htmlFor="emailFieldFormLogin"
                    name="Email"
                    value={values.Email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errors={errors.Email && touched.Email && errors.Email}
                    valid={!errors.Email && touched.Email && !errors.Email}
                    required
                  />
                </Margin>
                <Margin mb={1}>
                  <Input
                    label="Senha"
                    placeholder="Digite sua senha cadastrada"
                    htmlFor="passwordFieldFormLogin"
                    name="Senha"
                    type="password"
                    value={values.Senha}
                    maxLength={32}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    showHidePassword={true}
                    valid={!errors.Senha && touched.Senha && !errors.Senha}
                    errors={errors.Senha && touched.Senha && errors.Senha}
                    required
                  />
                </Margin>
                <Margin mb={4}>
                  <Link
                    to={`/esqueci-minha-senha?${location.search}`}
                    id="forgotLinkFormLogin"
                  >
                    <S.ForgotLink>Esqueceu sua senha?</S.ForgotLink>
                  </Link>
                </Margin>
                <S.ButtonHolder>
                  <Button
                    className="animation-size"
                    color={
                      !isValid || !dirty || sending ? "disabled" : "primary"
                    }
                    type="submit"
                    disabled={!isValid || !dirty || sending}
                    id="sendButtonFormLogin"
                  >
                    {sending ? <Loading button /> : "Entrar"}
                  </Button>
                </S.ButtonHolder>
              </S.FormLimiter>
            )}
          </Formik>
        </Margin>
        {errorMessage && !participanteHash && (
          <Margin mb={3}>
            <Alert type="error">
              {errorMessage}
            </Alert>
          </Margin>
        )}
        <Margin mb={mobile ? 5 : 8} mt={6}>
          {!Code && (
            <S.TextHolder className="signup-container">
              <Text className={"text-black"}>Ainda não tem cadastro?</Text>
              <S.BtnSignUp
                className="animation-size"
                color={"primary"}
                onClick={() =>
                  history.push({
                    pathname: "/cadastre-se",
                    search: location.search,
                  })
                }
              >
                Cadastre-se
              </S.BtnSignUp>
            </S.TextHolder>
          )}
        </Margin>
      </S.FormHolder>
    </>
  );
}
